// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import type { ErrorsType } from "../../../account/types/UserFormType";
import FacebaseList from "../../components/facebases/FacebaseAdminList";
import { fetchFacebaseList } from "../../actions/facebaseAdminActions";
import { fetctAllUsers } from "../../actions/userAdminActions";
import { fetcCompanyList } from "../../actions/companyAdminActions";
import { LoadingProgress, SnackbarMessage, NoItem } from "imagus-components";
import { ErrosDisplay } from "../../../account/containers/ErrosDisplay";
import { companyDialogMessages } from "../../../account/components/companies/CompileCompanytoJson";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

type AdminFacebasesStateType = {
  errors: ErrorsType,
  messageId: number,
  snackOpen: boolean
};

class AdminFacebases extends Component<*, AdminFacebasesStateType> {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      messageId: 0,
      snackOpen: false
    };
  }

  componentDidMount() {
    this.props.actions.fetchFacebaseList();
    if(this.props.userList === null){
      this.props.actions.fetctAllUsers();
    }
    if(this.props.companies === null){
      this.props.actions.fetcCompanyList();
    }
  }

  setActionError = (errors: ErrorsType): * => {
    this.setState({
      errors: errors
    });
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  openSnackbar = (messageId: number): * => {
    this.setState({ messageId: messageId }, this.switchModalStatus("snackOpen")(true));
  }

  render(): * {
    const facebaseList = this.props.facebaseList && {...this.props.facebaseList};
    let facebaseNode = null;
    if (facebaseList) {
      if (Object.keys(facebaseList).length === 0) {
        facebaseNode = <NoItem content="No Facebase has created yet." />;
      }
      else {
        facebaseNode = <FacebaseList
          facebases={facebaseList}
          setActionError={this.setActionError}
          openSnackbar={this.openSnackbar}
        />;
      }
    }


    if (!facebaseNode) {
      return (
        <div className="app-panel">
          <LoadingProgress />
        </div>
      );
    }
    else {
      return (
        <div className="app-panel">
          <div className="top-banner">
            <ErrosDisplay errors={this.state.errors} form="admin facebases" />
          </div>
          <SnackbarMessage open={this.state.snackOpen} handleModalStatus={this.switchModalStatus("snackOpen")} message={companyDialogMessages[this.state.messageId]} />
          <div className="app-panel-content">
            <Paper elevation={4} style={{ padding: "16px " }}>
              <Grid container spacing={24}>
                <Grid item xs={6}>
                  <Typography variant="h2" align="center">
                    {Object.keys(facebaseList).length}
                  </Typography>
                  <Typography variant="h6" align="center">
                    FACEBASES
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h2" align="center">
                    NAN
                  </Typography>
                  <Typography variant="h6" align="center">
                    GIGABYTES
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </div>
          {facebaseNode}
        </div>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  facebaseList: state.v3admin.facebase.facebaseList,
  userList: state.v3admin.user.users,
  companies: state.v3admin.company.companies,
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchFacebaseList, fetctAllUsers, fetcCompanyList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminFacebases);
